export default __webpack_public_path__ + "favicons/safari-pinned-tab.svg";